import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { Link, useNavigate } from "react-router-dom";
import Images from "../Images";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
} from "../Components/Styles/PageStyles";
import { Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import {
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  SubmitBtn,
  PreviewBtn,
  FormContainerVertical,
  CombineInputGroup
} from "../Components/Styles/InputStyles.jsx";
import DropZone from "../Components/Dropzone";
import Loading from "../Components/Loading";
import { useMutation, useQuery } from "react-query";
import Config from "../Config";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Update_User } from "../Redux/actions";
//import SelectSearch from "react-select-search";
import "../select-search.css";
import Fuse from "fuse.js";
import ChangePasswordModal from "../Components/Admin/ChangePasswordModal";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../Components/Navbar";
import { MdPassword } from "react-icons/md";

const RegisterarDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [changePasswordModel, setChangePasswordModel] = useState(false);
  const [isInitialValueSaved, setIsInitialValueSaved] = useState(true);
  const user = useSelector((state) => state.UserReducer.user);
  const { t, i18n } = useTranslation();
    // ----- Getting Initial Data ------
  const fetchFunction = async () => {
    const body = new FormData();
    body.append("token", user.email);
    body.append("userType", user.userType);
    body.append("type", 3);
    return await axios.post(`${Config.apiUrl}/getusers`, 
    body, 
    {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const { isLoadingFetch, error, data, refetch, isRefetchingFetch } = useQuery(
    "RegisterarDetails",
    fetchFunction
  );

  useEffect(()=>{
    // setTypeOfReg (data?.data?.data?.typeOfReg);
    // setTypeOfRegLabel (data?.data?.data?.typeOfRegLabel);
    // setTypeOfAssocLabel (data?.data?.data?.typeOfAssocLabel);
    // setRegionLabel (data?.data?.data?.regionLabel);
    // setDistrictLabel (data?.data?.data?.districtLabel);
    // SetDynamicAssociation (data?.data?.data?.typeOfReg);
    // SetDynamicDistricts (data?.data?.data?.region);
     setIsInitialValueSaved (false);
    // setGameLabel(data?.data?.data?.gameLabel);
  },[data])
  // change password
  const changePasswordFunction = async (values) =>{
    const body = new FormData();
    body.append("password", values.password);
    body.append("email", data?.data?.data[0]?.email);
    body.append("confirmPassword", values.confirmPassword);
    return await axios.post(
      Config.apiUrl + "/changepasswordbyadmin",
      body,
      {
        headers: {
          authorization: user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );}

  const onChangePasswordSuccess = (data) => {
    if (data?.data?.status == 'OK')
    {
      toast.success(data?.data?.msg || "Success");
      //refetch();
      setChangePasswordModel(false);
    }
    else
    {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    
  };

  const onChangePasswordError = (data) => {
    toast.error(data?.data?.msg, "An Error Occured");
  };

  const { mutate: changePasswordMutate, isLoading: changePasswordLoading } =
    useMutation(changePasswordFunction, {
      onSuccess: onChangePasswordSuccess,
      onError: onChangePasswordError,
    });

// update profile
  const updateProfileFunction = async (values) => {
    const body = new FormData();
    body.append("fName", values.fName);
    body.append("lName", values.lName);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    body.append("status", values.status);
    return await axios.post(
    Config.apiUrl + "/updateregisterar",
    body,
    {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  }

const onSuccess = (data) => {
  toast.success(data?.data?.msg, "Success");
};

const onError = (data) => {
  toast.error(data?.response?.data?.msg, "An Error Occured");
};

const { mutate: updateProfileMutate, isLoading: isLoading } =
  useMutation(updateProfileFunction, {
    onSuccess: onSuccess,
    onError: onError,
  });


  const initialValues = {
    fName: data?.data?.data[0]?.fName || "",
    lName: data?.data?.data[0]?.lName || "",
    email: data?.data?.data[0]?.email || "",
    mobile: data?.data?.data[0]?.mobile || "",
    status: data?.data?.data[0]?.status || ""
  };

  const SubmitHandler = async (values) => {
    //setChangePasswordModel(true);
    updateProfileMutate(values);
  };

  return (
    <>  
    <Navbar />
    <Page>
      <BoxContainer>
      <div className="flex w-full justify-between items-center">
        <div>
          <Title>{t("Registrar_Details")}</Title>
          <Underline />
        </div>
        <Uploader setChangePasswordModel={setChangePasswordModel} />
      </div>
        {changePasswordModel && (user.userType==1) && (
          <ChangePasswordModal
            setChangePasswordModel={setChangePasswordModel}
            changePasswordLoading={changePasswordLoading}
            changePasswordMutate={changePasswordMutate}
          />
        )}

        <div className="mt-10">
          {(user.userType==1) && data && (<Formik initialValues={initialValues} onSubmit={SubmitHandler} enableReinitialize={isInitialValueSaved}>
            {
            (formikProps) => (
              <Form>
                <FormContainerVertical className=" w-full max-w-xl md:ml-10">
                <InputGroup>
                    <Label htmlFor="email">{t("u_email")}</Label>
                    <FieldWrapper>
                      <Field
                        name="email"
                        type="email"
                        id="email"
                        placeholder=""
                        disabled
                      />
                    </FieldWrapper>
                </InputGroup>
                <CombineInputGroup>
                    <InputGroup>
                      <Label htmlFor="fName">{t("fname")}</Label>
                      <FieldWrapper>
                        <Field
                          name="fName"
                          type="text"
                          id="fName"
                          placeholder="e.g. Hellan Johnson"
                        />
                      </FieldWrapper>
                    </InputGroup>
                    <InputGroup>
                      <Label htmlFor="lName">{t("lname")}</Label>
                      <FieldWrapper>
                        <Field
                          name="lName"
                          type="text"
                          id="lName"
                          placeholder="e.g. Hellan Johnson"
                        />
                      </FieldWrapper>
                    </InputGroup>
                  </CombineInputGroup>
                  
                  <InputGroup>
                    <Label htmlFor="phone">{t("u_m_number")}</Label>
                    <FieldWrapper>
                      <Field
                        name="mobile"
                        type="number"
                        id="mobile"
                        placeholder=""
                        disabled
                      />
                    </FieldWrapper>
                  </InputGroup>
                  <InputGroup>
                <Label htmlFor="status">Status</Label>
                <FieldWrapper $select={true}>
                  <Field required name="status" id="status" autoComplete="off">
                    {(props) => (
                      <Select
                        className="w-full h-full pl-2"
                        {...props.field}
                      >
                        <MenuItem value="1">Active</MenuItem>
                        <MenuItem value="2">InActive</MenuItem>
                      </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup>
                </FormContainerVertical>
                <SubmitBtnWrapper className="md:ml-10">
                <div className="flex items-center space-x-10">
                  <SubmitBtn type="submit" className="text-sm md:text-sm">
                    {t("Update")}
                  </SubmitBtn>
                 
                </div>
                </SubmitBtnWrapper>
                
              </Form>
            )
            }
          </Formik>)}

          {(user.userType!=1) && (<Wrapper>
                <SingleItem name={"Registrar Name"} value={data?.data?.data[0]?.name} />
                <SingleItem name={"Mobile"} value={data?.data?.data[0]?.mobile} />
                <SingleItem name={"Email"} value={data?.data?.data[0]?.email} />
                <SingleItem name={"Status"} value={(data?.data?.data[0]?.status==1)? "Active" : "Inactive"} />

                {/* <SingleItem name={"Remarks"} value={selectedItem?.remarks}  />
                <SingleItem name={"Dated"} value={selectedItem?.dated} /> */}
          </Wrapper>)}
        </div>
      </BoxContainer>
    </Page>
    </>
  );
};


const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);
const Uploader = ({ setChangePasswordModel }) => {
  const user = useSelector((state) => state.UserReducer.user);

  return (
    <UploadWrapper>
      {
        (user.userType==1) && (<Button type="button" onClick={() => setChangePasswordModel(true)}>
        <MdPassword className="text-white w-5 h-5" /> <p>Change Password</p>
      </Button>)}
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const SubmitBtnWrapper = tw.div`
mt-10 `;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;
const Wrapper = tw.div`px-4`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;

export default RegisterarDetails;
